import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './middle-buttons.styl';
import { GenericButton } from 'shared/components/button/button';
import { RoundedIcon } from 'shared/components/icon/icon';


export const PlayButton = ({ onClick, children }) => (
  <GenericButton renderAsLink
                 className={styles.play}
                 onClick={onClick}
                 dataHook="overlay-play-button">
    <RoundedIcon className={classnames(styles.icon, styles['play-icon'])}
                 name="arrow-right-filled" />
    <span className={styles.text}>
      {children}
    </span>
  </GenericButton>
);

PlayButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export const PurchaseButton = ({ onClick, children }) => (
  <GenericButton renderAsLink
                 className={styles.purchase}
                 onClick={onClick}
                 dataHook="overlay-play-button">
    <span className={styles.text}>
      {children}
    </span>
  </GenericButton>
);

PurchaseButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/mobile/three-rows-widget/buttons/middle-buttons.js